import { render, staticRenderFns } from "./edit_new_post_config.vue?vue&type=template&id=6cf71c14&"
import script from "./edit_new_post_config.vue?vue&type=script&lang=js&"
export * from "./edit_new_post_config.vue?vue&type=script&lang=js&"
import style0 from "./edit_new_post_config.vue?vue&type=style&index=0&id=6cf71c14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports